<script setup lang="ts">
import { XLogo } from '@clicksign/excalibur';

import { useCurrentSignatureRequestKey } from '~~core';
import { useBrand, useFetchBrand } from '~~base-ui';

const { signatureRequestKey } = useCurrentSignatureRequestKey();
const { isLoading, brand } = useFetchBrand(signatureRequestKey);
const { colors, logoUrl } = useBrand(brand);
</script>

<template>
  <header
    :class="[$style.header, isLoading && $style.isLoading]"
    :style="{ backgroundColor: colors.brandColor }"
    data-testid="theHeader"
  >
    <img
      v-if="logoUrl"
      :class="$style.brandLogo"
      :src="logoUrl"
    >
    <XLogo
      v-else
      color="white"
      height="32px"
      data-testid="clicksignLogo"
    />
  </header>
</template>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: var(--space-small-xx) var(--space-large-xx);
  transition-duration: var(--time-transition-short);

  &.isLoading {
    opacity: 0;
  }
}

.brandLogo {
  max-width: 100%;
  height: max-content;
  max-height: 32px;
}
</style>
